export const formatPrice = (
  price: number | null,
  fixedTo?: number,
  withoutCurrency = false
): string => {
  if (price === 0 || price === undefined || price == null) return '';

  if (withoutCurrency) {
    return new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: fixedTo || (price % 1 !== 0 ? 2 : 0),
      maximumFractionDigits: fixedTo || (price % 1 !== 0 ? 2 : 0)
    }).format(price);
  }

  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: fixedTo || (price % 1 !== 0 ? 2 : 0),
    maximumFractionDigits: fixedTo || (price % 1 !== 0 ? 2 : 0)
  }).format(price);
};
